import {
    orange50,
    orange200,
    orange400,
    orange700,
    grey900,
} from "material-ui/styles/colors";

var OrangeTheme = {
    fontFamily: "arial",
    palette : {
        primary1color:      orange700,
        primary2color:      orange400,
        primary3color:      orange200,
        accent1color:       "#E73677",
        accent2color:       "#D0FFCA",
        accent3color:       "#FF9797",
        textColor:          grey900,
        canvasColor:        orange50,
        alternateTextColor: orange200, // Button background color.
    }
};

export default OrangeTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/OrangeTheme.js
 **/